import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Params, Router } from '@angular/router';
import { AppConfigurationService } from '../../app-configuration.service';
import { Utils } from '../Utils/Utils';

@Injectable()
export class RedirectBeforeGuard implements CanActivate {
  constructor(
    private router: Router,
    private configurationService: AppConfigurationService
  ) {}

  canActivate(route: ActivatedRouteSnapshot) {
    const val: Params = route.queryParams;

    if (val && val['c-sig']) {
      return true;
    } else {
      const queryParams = { 'c-sig': this.configurationService.clientSignature };
      const params = { ...val, ...queryParams };
      this.router.navigate([Utils.getBaseRoute()], { queryParams: params, fragment: 'Q1' });
      return false;
    }
  }
}
